import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sm-tooltip-dialog',
  templateUrl: './sm-tooltip-dialog.component.html',
  styleUrls: ['./sm-tooltip-dialog.component.scss']
})
export class SmTooltipDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SmTooltipDialogComponent>
  ) { }

  ngOnInit(): void {
  }

}
